(function () {
  'use strict';

  var root = document.getElementById('Pdp-Additional-Information-Section');
  if (!root) return;

  // Mobile-Accordion: nur unterhalb 768px aktiv; ab Tablet zeigt das CSS die
  // Beschreibungen dauerhaft (max-height: none), Klicks bleiben wirkungslos.
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  var cards = root.querySelectorAll('.pdp-additional-information-flat__card');
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      if (!mobileQuery.matches) return;

      var body = card.querySelector('.pdp-additional-information-flat__card-body');
      if (!body) return;

      var wasOpen = card.classList.contains('is-open');

      root.querySelectorAll('.pdp-additional-information-flat__card.is-open').forEach(function (openCard) {
        openCard.classList.remove('is-open');
        var openBody = openCard.querySelector('.pdp-additional-information-flat__card-body');
        if (openBody) openBody.style.maxHeight = null;
      });

      if (!wasOpen) {
        card.classList.add('is-open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });
})();
